import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { catchError, Subscription } from 'rxjs';
import { User } from '../models/user';
import { FacilityAssignment } from '../models/facility-assignment';
import { UsersService } from '../services/users.service';
import {
  MatTableDataSource,
  MatTableModule,
  MatCheckboxModule,
  MatIconModule,
} from 'src/app/shared/material';
import { AssignedFacilityDataSource, Facility } from 'src/app/shared/models';
import {
  PanelBodyComponent,
  PanelContainerComponent,
  PanelHeaderComponent,
  panelSlider,
} from 'src/app/shared/content-panels';
import { SpinnerService } from 'src/app/shared/services';

@Component({
    selector: 'app-user-detail-view',
    imports: [
    DatePipe,
    MatCheckboxModule,
    MatTableModule,
    MatIconModule,
    PanelContainerComponent,
    PanelBodyComponent,
    PanelHeaderComponent
],
    animations: [panelSlider],
    templateUrl: './user-detail-view.component.html',
    styleUrl: './user-detail-view.component.scss'
})
export class UserDetailViewComponent implements OnChanges {
  @Input() user: User;
  @Output() close = new EventEmitter();

  isEditMode = false;
  allAssigned = false;
  changesMade = false;
  assignedFacilities = new MatTableDataSource<AssignedFacilityDataSource>([]);
  private _facilitiesCollection: Facility[];
  private _subscriptions: Subscription[] = [];
  private _originalFacilityAssignments: FacilityAssignment[];

  constructor(
    public userSrv: UsersService,
    private spinnerService: SpinnerService
  ) {}

  ngOnInit() {
    var sub = this.userSrv.facilities$.subscribe((result) => {
      this._facilitiesCollection = result
        .map((i) => new Facility(i))
        .sort(
          (a, b) =>
            parseInt(a.KeyChain.LegacyId) - parseInt(b.KeyChain.LegacyId)
        );
    });

    this._subscriptions.push(sub);
  }

  ngOnDestroy() {
    this._subscriptions.forEach((i) => i.unsubscribe());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['user'] && !changes['user'].firstChange) {
      this.isEditMode = false;
      this.changesMade = false;
      this._originalFacilityAssignments = undefined;
    }
  }

  toggleEditMode() {
    this.isEditMode = true;
    this.changesMade = false;

    this._originalFacilityAssignments = this.user.FacilityAssignments.map(
      (i) => ({ ...i })
    );

    this.assignedFacilities.data =
      this.userSrv.generateAssignedFacilitiesDataSource(
        this.user,
        this._facilitiesCollection
      );

    this.allAssigned =
      this.assignedFacilities.data.filter((i) => !i.Assigned)?.length == 0;
  }

  closePanel() {
    this.close.emit();
  }

  hasUnsavedChanges(): boolean {
    return this.isEditMode && this.changesMade;
  }

  discardChanges(): void {
    this.isEditMode = false;
    this.changesMade = false;

    if (this._originalFacilityAssignments) {
      this.user.FacilityAssignments = this._originalFacilityAssignments;
      this._originalFacilityAssignments = undefined;
    }
  }

  updateAssignedFacility(fac: AssignedFacilityDataSource) {
    this.userSrv.updateFacilityAssignments(
      this.user,
      this._facilitiesCollection,
      this.assignedFacilities.data,
      fac
    );

    this.changesMade = true;
    this.allAssigned =
      this.assignedFacilities.data.filter((i) => !i.Assigned)?.length == 0;
  }

  assignAllFacilities(checked: boolean) {
    this.assignedFacilities.data.map((i) => {
      i.Assigned = checked;
      this.updateAssignedFacility(i);
    });

    this.allAssigned = checked;
  }

  updateDefaultAssignedFacility(fac: AssignedFacilityDataSource) {
    this.userSrv.updateDefaultAssignedFacility(
      this.user,
      this._facilitiesCollection,
      this.assignedFacilities.data,
      fac
    );

    this.changesMade = true;
  }

  saveChanges() {
    this.isEditMode = false;
    this.changesMade = false;
    this._originalFacilityAssignments = undefined;
    this.spinnerService.show();
    this.userSrv.saveFacilityAssignments(this.user).subscribe({
      complete: () => {
        this.spinnerService.hide();
      },
      error: (err) => {
        console.log('service error', err);
        this.spinnerService.hide();
      },
    });
  }
}
